import { render, staticRenderFns } from "./ProductColors.vue?vue&type=template&id=046ad33a&scoped=true&"
import script from "./ProductColors.vue?vue&type=script&lang=js&"
export * from "./ProductColors.vue?vue&type=script&lang=js&"
import style0 from "./ProductColors.vue?vue&type=style&index=0&id=046ad33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ad33a",
  null
  
)

export default component.exports